import React, { useState, useEffect } from 'react'
import Toggle from 'components/UIComponents/Toggle'
import TreeFilter from 'components/TreeSelectFilter'
import Button from 'components/Button'
import {
  HeaderWrapper,
  ToggleRow,
  FilterSection,
  FilterGroup,
  CheckboxContainer,
  ActionRow,
} from '../../style/style'
import { Checkbox } from 'antd'
import College from './College'
import Group from './Group'

const GroupCollegeHeader = ({
  tableType,
  setTableType,
  setviewGroupCollege,
  collegeData,
  setCollegeData,
  loading,
  setLoading,
  pageNum,
  pageLimit,
  groupCreationDrawerVisible,
  setGroupCreationDrawerVisible,
  setGroupData,
  groupData,
  totalCollegeCount,
  groupCount,
  handleEditTier,
  handleEditPOC,
  pocList,
  handleAddPOC,
  handleAddToGroup,
  handleAdd,
  handleDelete,
  handleEdit,
  handleAddQueue,
  handleSort,
  onSelectChange,
  onPageChange,
  showDeleteGroupPopup,
  showDuplicatePopup,
  selectedColleges,
  setSelectedColleges,
  onCollegeSelectChange,
  selectedCollegeIds,
  onSingleRowSelect,
  onSelectAllRows,
  onViewSelectedColleges,
  handleCreateNewGroup,
  selectedGroupPagination,
  onTabChange,
  collegeFilters,
  setCollegeFilters,
  handleCollegeFilterChange,
  filterData,
  collegeSearch,
  fetchGroupList,
  searchValue,
  currentGroupSearch,
  setCollegeSearch,
  selectedGroupIds,
  handlePublishRole,
  handleSkip,
  isEditRoleOnView,
  isRepublishMode,
  publishedIds = [],
  publishedCount = 0,
  onViewPublished,
  // Add new props for dropdown search/refresh
  stateOptions,
  cityOptions,
  onStateSearch,
  onCitySearch,
  onStateDropdownClose,
  onCityDropdownClose,
}) => {
  const value = 200
  const [activeTab, setActiveTab] = useState('colleges')

  useEffect(() => {
    if (onTabChange) onTabChange(activeTab)
  }, [activeTab])

  const isDisabled =
    (activeTab === 'colleges' &&
      (!selectedColleges || selectedColleges.length === 0)) ||
    (activeTab === 'groups' &&
      (!selectedGroupIds || selectedGroupIds.length === 0))
  return (
    <>
      <div style={{ padding: 24 }}>
        {/* Already-published banner — shown whenever the role already has
            published colleges (refresh-proof, data-driven). */}
        {publishedCount > 0 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 16,
              padding: '12px 16px',
              marginBottom: 20,
              background: '#EEF0FF',
              border: '1px solid #C7CEFF',
              borderRadius: 12,
            }}
          >
            <span
              style={{
                fontSize: 14,
                fontWeight: 500,
                color: '#1D4ED8',
                fontFamily: 'Plus Jakarta Sans, sans-serif',
              }}
            >
              This role is already published to <b>{publishedCount}</b>{' '}
              {publishedCount === 1 ? 'institute' : 'institutes'}.
            </span>
            <button
              type="button"
              onClick={() => onViewPublished && onViewPublished()}
              style={{
                height: 36,
                padding: '0 16px',
                borderRadius: 10,
                background: '#fff',
                color: '#3249D7',
                fontSize: 14,
                fontWeight: 600,
                fontFamily: 'Plus Jakarta Sans, sans-serif',
                border: '1px solid #3249D7',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                transition: 'all 0.2s ease',
              }}
            >
              Already Published ({publishedCount})
            </button>
          </div>
        )}
        {/* Tabs Container */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 24,
          }}
        >
          {/* Tabs */}
          <div
            style={{
              display: 'flex',
              padding: 4,
              background: '#fff',
              border: '1px solid #e0e0e0',
              borderRadius: 12,
            }}
          >
            {/* Colleges Tab */}
            <div
              onClick={() => setActiveTab('colleges')}
              style={{
                padding: '8px 20px',
                borderRadius: 12,
                backgroundColor:
                  activeTab === 'colleges' ? '#EEF0FF' : 'transparent',
                color: activeTab === 'colleges' ? '#1D4ED8' : '#c4c4c4',
                fontWeight: activeTab === 'colleges' ? 600 : 500,
                fontSize: 16,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
            >
              Colleges ({totalCollegeCount})
            </div>

            {/* Groups Tab */}
            <div
              onClick={() => setActiveTab('groups')}
              style={{
                padding: '8px 20px',
                borderRadius: 12,
                backgroundColor:
                  activeTab === 'groups' ? '#EEF0FF' : 'transparent',
                color: activeTab === 'groups' ? '#1D4ED8' : '#c4c4c4',
                fontWeight: activeTab === 'groups' ? 600 : 500,
                fontSize: 16,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
            >
              My Groups ({groupCount})
            </div>
          </div>

          {/* Skip + Publish Buttons */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {/* Skip button — republish/edit mode. Lets the user finalize
                without selecting any new college. */}
            {isRepublishMode && (
              <Button
                onClick={() => handleSkip && handleSkip()}
                style={{
                  height: 40,
                  padding: '0 20px',
                  borderRadius: 12,
                  backgroundColor: '#ffffff',
                  color: '#3249D7',
                  fontSize: 16,
                  fontWeight: 500,
                  border: '1px solid #3249D7',
                  cursor: 'pointer',
                }}
              >
                Skip
              </Button>
            )}
            {/* Publish Button */}
            <Button
              disabled={isDisabled}
              onClick={() => handlePublishRole()}
              style={{
                height: 40,
                padding: '0 20px',
                borderRadius: 12,
                backgroundColor: isDisabled ? '#e0e0e0' : '#3249D7',
                color: '#ffffff',
                fontSize: 16,
                fontWeight: 500,
                border: 'none',
                cursor: isDisabled ? 'not-allowed' : 'pointer',
              }}
            >
              Publish Role
            </Button>
          </div>
        </div>

        {activeTab === 'colleges' ? (
          <College
            handleSort={handleSort}
            collegeData={collegeData}
            setCollegeData={setCollegeData}
            loading={loading}
            setLoading={setLoading}
            pageNum={pageNum}
            pageLimit={pageLimit}
            totalCollegeCount={totalCollegeCount}
            setGroupCreationDrawerVisible={setGroupCreationDrawerVisible}
            groupCreationDrawerVisible={groupCreationDrawerVisible}
            handleEditTier={handleEditTier}
            handleEditPOC={handleEditPOC}
            pocList={pocList}
            handleAddPOC={handleAddPOC}
            handleAddToGroup={handleAddToGroup}
            selectedColleges={selectedColleges}
            onCollegeSelectChange={onCollegeSelectChange}
            onPageChange={onPageChange}
            selectedCollegeIds={selectedCollegeIds}
            publishedIds={publishedIds}
            onSingleRowSelect={onSingleRowSelect}
            onSelectAllRows={onSelectAllRows}
            onViewSelectedColleges={onViewSelectedColleges}
            collegeFilters={collegeFilters}
            setCollegeFilters={setCollegeFilters}
            handleCollegeFilterChange={handleCollegeFilterChange}
            activeTab={activeTab}
            filterData={filterData}
            collegeSearch={collegeSearch}
            setCollegeSearch={setCollegeSearch}
            // Pass new props
            stateOptions={stateOptions}
            cityOptions={cityOptions}
            onStateSearch={onStateSearch}
            onCitySearch={onCitySearch}
            onStateDropdownClose={onStateDropdownClose}
            onCityDropdownClose={onCityDropdownClose}
          />
        ) : (
          <Group
            groupData={groupData}
            setGroupData={setGroupData}
            loading={loading}
            setLoading={setLoading}
            pageNum={pageNum}
            pageLimit={pageLimit}
            setGroupCreationDrawerVisible={setGroupCreationDrawerVisible}
            groupCreationDrawerVisible={groupCreationDrawerVisible}
            handleAdd={handleAdd}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
            handleAddQueue={handleAddQueue}
            handleSort={handleSort}
            onSelectChange={onSelectChange}
            onPageChange={onPageChange}
            showDeleteGroupPopup={showDeleteGroupPopup}
            showDuplicatePopup={showDuplicatePopup}
            handleAddToGroup={handleAddToGroup}
            handleCreateNewGroup={handleCreateNewGroup}
            selectedGroupPagination={selectedGroupPagination}
            activeTab={activeTab}
            fetchGroupList={fetchGroupList}
            searchValue={searchValue}
            currentGroupSearch={currentGroupSearch}
          />
        )}
      </div>
    </>
  )
}

export default GroupCollegeHeader
